import logo  from './logo.png';
import imagen1 from './imagen1.png';
import imagen2 from './imagen2.jpg';
import imagen3 from './imagen3.png';
import imagen4 from './imagen4.jpg';
import imagen5 from './imagen5.jpg';
import imagen6 from './imagen6.jpg';
import imagen7 from './imagen7.jpg';
import imagen8 from './imagen8.jpg';
import imagen9 from './imagen9.jpg';
import imagen10 from './imagen10.jpg';
import imagen11 from './imagen11.jpg';
import Ariadna from './Ariadna.jpeg';

export default {
    "img0": logo, 
    "img1": imagen1,
    "img2": imagen2,
    "img3": imagen3,
    "img4": imagen4,
    "img5": imagen5,
    "img6": imagen6,
    "img7": imagen7,
    "img8": imagen8,
    "img9": imagen9,
    "img10": imagen10,
    "img11": imagen11,
    "img12": Ariadna, 
    
}